import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";
import { CouponCreatedProps, CouponProps, RedeemCouponProps, stateStatusType } from "./actionType";

export interface FetchCouponState {
  isLoading: boolean;
  error: string | null;
  coupon: CouponProps[] | null; // list
  status: stateStatusType | null;
}

export interface GenericCouponState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
  data: CouponCreatedProps | null
  redeemData: RedeemCouponProps | null
}


export const initalFetchCouponState: FetchCouponState = {
  isLoading: false,
  error: null,
  coupon: null,
  status: null,
};

export const initialGenericCouponState: GenericCouponState = {
  isLoading: false,
  error: null,
  status: null,
  data:null,
  redeemData: null
};

export interface CouponState {
  fetchCouponState: FetchCouponState;
  genericCouponState : GenericCouponState
}

export const initialState: CouponState = {
  fetchCouponState: initalFetchCouponState,
  genericCouponState:initialGenericCouponState
}

